// Business rules for exceptions
// https://imagitas.atlassian.net/wiki/spaces/MGODev/pages/573276161/MGO+Address+Type+Mover+Type+Business+Rules

const poBoxException = [
  'R777AddressException',
  'PoBoxRequiredException',
  'InvalidPrimaryPoBoxException',
];
const primvateMailboxException = [
  'CmraAddressException',
  'CCR1CmraAddressException',
];

export default {
  data() {
    return {
      oldAddressError: '',
      newAddressError: '',
      billingAddressError: '',
    };
  },
  watch: {
    // Po box exceptions are reset on street address change
    // since a user can either use the street address field
    // or the po box field to satisfy API address validation
    oldStreetAddress() {
      this.oldAddressError = '';
    },
    newStreetAddress() {
      this.newAddressError = '';
    },
    billingStreetAddress() {
      this.billingStreetAddressError = '';
    },
    moverType(currState) {
      if (this.oldAddressError === 'MilitaryAddressException' && currState !== 'BUSINESS') {
        this.oldAddressError = '';
      }
    },
  },
  computed: {
    oldPoBoxException() {
      return (!this.oldStreetHasPoBox && [...poBoxException].includes(this.oldAddressError));
    },
    oldStreetHasPoBox() {
      return this.includesPoBox(this.oldStreetAddress);
    },
    showOldPoBox() {
      return (
        this.oldPoBoxException
        || (!this.oldStreetHasPoBox && this.oldAddressError === 'OldPoBoxRequiredException')
        || this.oldPoBoxNumber
      );
    },
    newStreetHasPoBox() {
      return this.includesPoBox(this.newStreetAddress);
    },
    newPoBoxException() {
      return (
        !this.newStreetHasPoBox && [...poBoxException, 'NewPoBoxRequiredException'].includes(this.newAddressError)
      );
    },
    showNewPoBox() {
      return this.newPoBoxException
        || (!this.newStreetHasPoBox && this.newAddressError === 'NewPoBoxRequiredException')
        || this.newPoBoxNumber;
    },
    showNewPrivateMailbox() {
      return this.newPrivateMailbox
      || [...primvateMailboxException].includes(this.newAddressError);
    },
    billingStreetHasPoBox() {
      return this.includesPoBox(this.billingStreetAddress);
    },

    billingPoBoxException() {
      return [...poBoxException].includes(this.billingAddressError);
    },
    showBillingPoBox() {
      return (this.billingPoBoxException && !this.billingStreetHasPoBox
        && this.billingStreetAddress?.length > 0)
      || this.billingAddressError === 'ThirdPoBoxRequiredException'
      || this.billingPoBoxNumber;
    },

    showBillingPrivateMailbox() {
      return this.billingPrivateMailbox
      || [...primvateMailboxException].includes(this.billingAddressError);
    },
  },
  methods: {
    evaluateErrorRedirect({ xhr }) {
      if (xhr?.addressType === 'OLD' && xhr?.exception === 'CmraAddressException') {
        return 'cmra';
      }

      if (xhr?.addressType === 'OLD' && xhr?.exception === 'BusinessMoverTypeException') {
        return 'residential-business';
      }

      if (xhr?.addressType === 'OLD' && xhr?.exception === 'UniqueZipException') {
        return 'old-unique-zip';
      }

      return '';
    },
    includesPoBox(testStr) {
      const regex = /^(po)\s?(box)\s*\d\w+\s*$/gi;
      return regex.test(testStr);
    },
    // log the exception on 422 error exceptions or 200 amsStatusCodes
    defaultException(exception) {
      this.$coa.addressException(
        exception || 'UnclassifiedResponse',
        {
          streetAddress: this?.oldStreetAddress,
          city: this?.oldCity,
          state: this?.oldState,
          zipCode: this?.oldZipCode,
        },
        {
          streetAddress: this?.newStreetAddress,
          city: this?.newCity,
          state: this?.newState,
          zipCode: this?.newZipCode,
        },
        {
          streetAddress: this?.billingStreetAddress,
          city: this?.billingCity,
          state: this?.billingState,
          zipCode: this?.billingZipCode,
        },
      );
    },
    // checks if amsStatusCode is duplicate
    isAmsMatch(amsStatusCode) {
      return amsStatusCode === 'EXACT_MATCH' || amsStatusCode === 'DEFAULT';
    },
  },
};
